<!-- 同一券面複数利用制限のダイアログ -->
<template>
  <ItemDialog ref="DialogMaxConcurrentUsingOver" imageType="alert">
    <template v-slot:content-area>
      <p>すでに使用中のチケットと同じ種類のチケットは使用できません。</p>
    </template>
    <template v-slot:button-area>
      <ItemButton label="OK" actionType="btn-primary" @clicked="closeDialog" />
    </template>
  </ItemDialog>
</template>

<script>
import { onMounted, computed, watchEffect, ref } from "vue";

export default {
  name: "DialogMaxConcurrentUsingOver",
  setup() {
    const DialogMaxConcurrentUsingOver = ref(null);

    const openDialog = () => {
      DialogMaxConcurrentUsingOver.value.open();
    };

    const closeDialog = () => {
      DialogMaxConcurrentUsingOver.value.close();
    };

    return {
      DialogMaxConcurrentUsingOver,
      openDialog,
      closeDialog,
    };
  },
};
</script>
